const { id, log } = require("../std/index")


//
// Coupon Code Widget
//

module.exports = class CouponCodeWidget {
  constructor($host, config) {
    this.KEY_ENTER = 13;

    this.config = config;
    this.dom = {
      main: $host,
      input: $('[data-input]', $host),
      button: $('[data-apply]', $host),
      response: $('[data-response]', $host)
    };

    this.state = {
      code: ""
    };

    // Listeners
    this.dom.input.on('keypress', this.submitIfReturn.bind(this));
    this.dom.button.on('click', this.submit.bind(this));
    this.dom.response.on('click', '.close', this.dismissResponse.bind(this));
  }

  setButtonEnabled(state = true) {
    this.dom.button.css({ opacity: state ? 1 : 0.5 });
  }

  submit() {
    this.setButtonEnabled(false);
    this.dismissResponse();

    const data = { [this.config.keyname]: this.dom.input.val() };

    log('submitting...', 'route:', this.config.route, 'data:', data);

    $.ajax({
      url: this.config.route,
      data: data,
      type: 'get',
      success: this.appendResponse.bind(this),
      error: this.setButtonEnabled.bind(this)
    });
  }

  submitIfReturn({ which }) {
    if (which === this.KEY_ENTER) {
      log('submit-on-return');
      this.submit();
      return false;
    }
  }

  appendResponse(html) {
    log(html);
    this.setButtonEnabled(true);
    this.dom.response.html(html);
  }

  dismissResponse() {
    log('dismiss');
    this.dom.response.html('');
  }
};
